// 'use client';

// import { useRef, useState } from 'react';

// export default function VideoFeatureSection() {
//   const videoRef = useRef<HTMLVideoElement>(null);
//   const [isPlaying, setIsPlaying] = useState(true);
//   const [showControl, setShowControl] = useState(false);

//   const toggleVideo = () => {
//     const video = videoRef.current;
//     if (!video) return;

//     if (video.paused) {
//       video.play();
//     } else {
//       video.pause();
//     }
//   };

//   return (
//     <section className="relative w-full bg-[#303030] py-16 sm:py-20 lg:py-24">
//       <div className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-10">
//         <div className="grid items-center gap-10 lg:grid-cols-2">
//           {/* VIDEO */}
//           <div className="relative mx-auto w-full max-w-[420px] sm:max-w-[480px] lg:max-w-[520px]">
//             <div
//               className="group relative overflow-hidden rounded-[6px]"
//               onMouseEnter={() => setShowControl(true)}
//               onMouseLeave={() => setShowControl(false)}
//             >
//               <video
//                 ref={videoRef}
//                 autoPlay
//                 muted
//                 loop
//                 playsInline
//                 preload="auto"
//                 className="h-[520px] w-full object-cover"
//                 onPlay={() => setIsPlaying(true)}
//                 onPause={() => setIsPlaying(false)}
//               >
//                 <source src="/video/gate-10.mp4" type="video/mp4" />
//               </video>

//               <button
//                 type="button"
//                 onClick={toggleVideo}
//                 aria-label={isPlaying ? 'Pause video' : 'Play video'}
//                 className={`absolute inset-0 flex items-center justify-center transition-opacity duration-300 ${
//                   !isPlaying || showControl ? 'opacity-100' : 'opacity-0'
//                 }`}
//               >
//                 <div className="flex h-[88px] w-[88px] items-center justify-center rounded-full border border-white/60 bg-black/25 backdrop-blur-md transition-transform duration-200 group-hover:scale-105">
//                   {isPlaying ? (
//                     <div className="flex gap-[6px]">
//                       <span className="block h-[22px] w-[6px] rounded-sm bg-white" />
//                       <span className="block h-[22px] w-[6px] rounded-sm bg-white" />
//                     </div>
//                   ) : (
//                     <div className="ml-1 h-0 w-0 border-y-[12px] border-y-transparent border-l-[20px] border-l-white" />
//                   )}
//                 </div>
//               </button>
//             </div>
//           </div>

//           {/* TEXT */}
//           <div className="relative text-[#b3b3b3]">
//             <div className="pointer-events-none absolute -right-4 -top-4 h-[120px] w-[120px] border-t border-r border-purple-500" />
//             <div className="pointer-events-none absolute -bottom-4 -left-4 h-[120px] w-[120px] border-b border-l border-purple-500" />

//             <h2 className="mt-4 text-[32px] font-bold leading-[1.1] text-[#b4b4b4] sm:text-[40px] lg:text-[50px]">
//               The world’s first-of-Its-kind speed gate
//             </h2>

//             <p className="mt-6 max-w-[420px] text-[14px] leading-[1.6] text-white sm:text-[16px] lg:text-[18px]">
//               We presented Sweeper-M to the world at exhibition this year — and it left everyone
//               impressed and in love with its design and innovation.
//             </p>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

'use client';

import { useEffect, useRef, useState } from 'react';

export default function VideoFeatureSection() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const hideTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const [isPlaying, setIsPlaying] = useState(true);
  const [showControl, setShowControl] = useState(false);

  // 🔥 запуск таймера скрытия
  const startHideTimer = () => {
    if (hideTimeoutRef.current) {
      clearTimeout(hideTimeoutRef.current);
    }

    hideTimeoutRef.current = setTimeout(() => {
      setShowControl(false);
    }, 2000);
  };

  // 👆 любое взаимодействие (мышь / тап)
  const handleInteraction = () => {
    setShowControl(true);
    startHideTimer();
  };

  // ▶️ пауза / плей
  const toggleVideo = () => {
    const video = videoRef.current;
    if (!video) return;

    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }

    handleInteraction();
  };

  // 🧹 очистка таймера
  useEffect(() => {
    return () => {
      if (hideTimeoutRef.current) {
        clearTimeout(hideTimeoutRef.current);
      }
    };
  }, []);

  return (
    <section data-component-id="src/components/ui/VideoFeatureSection.tsx:140:4" data-component-path="src/components/ui/VideoFeatureSection.tsx" data-component-line="140" data-component-end-line="203" data-component-file="VideoFeatureSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22relative%20w-full%20bg-%5B%23303030%5D%20py-16%20sm%3Apy-20%20lg%3Apy-24%22%7D" className="relative w-full bg-[#303030] py-16 sm:py-20 lg:py-24">
      <div data-component-id="src/components/ui/VideoFeatureSection.tsx:141:6" data-component-path="src/components/ui/VideoFeatureSection.tsx" data-component-line="141" data-component-end-line="202" data-component-file="VideoFeatureSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mx-auto%20max-w-%5B1440px%5D%20px-4%20sm%3Apx-6%20lg%3Apx-10%22%7D" className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-10">
        <div data-component-id="src/components/ui/VideoFeatureSection.tsx:142:8" data-component-path="src/components/ui/VideoFeatureSection.tsx" data-component-line="142" data-component-end-line="201" data-component-file="VideoFeatureSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20items-center%20gap-10%20lg%3Agrid-cols-2%22%7D" className="grid items-center gap-10 lg:grid-cols-2">
          {/* VIDEO */}
          <div data-component-id="src/components/ui/VideoFeatureSection.tsx:144:10" data-component-path="src/components/ui/VideoFeatureSection.tsx" data-component-line="144" data-component-end-line="185" data-component-file="VideoFeatureSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20mx-auto%20w-full%20max-w-%5B420px%5D%20sm%3Amax-w-%5B480px%5D%20lg%3Amax-w-%5B520px%5D%22%7D" className="relative mx-auto w-full max-w-[420px] sm:max-w-[480px] lg:max-w-[520px]">
            <div data-component-id="src/components/ui/VideoFeatureSection.tsx:145:12" data-component-path="src/components/ui/VideoFeatureSection.tsx" data-component-line="145" data-component-end-line="184" data-component-file="VideoFeatureSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22group%20relative%20overflow-hidden%20rounded-%5B6px%5D%22%7D"
              className="group relative overflow-hidden rounded-[6px]"
              onMouseMove={handleInteraction} // 🖱 движение мыши
              onClick={handleInteraction} // 📱 тап
            >
              <video data-component-id="src/components/ui/VideoFeatureSection.tsx:150:14" data-component-path="src/components/ui/VideoFeatureSection.tsx" data-component-line="150" data-component-end-line="162" data-component-file="VideoFeatureSection.tsx" data-component-name="video" data-component-content="%7B%22elementName%22%3A%22video%22%2C%22className%22%3A%22h-%5B520px%5D%20w-full%20object-cover%22%7D"
                ref={videoRef}
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                className="h-[520px] w-full object-cover"
                onPlay={() => setIsPlaying(true)}
                onPause={() => setIsPlaying(false)}
              >
                <source data-component-id="src/components/ui/VideoFeatureSection.tsx:161:16" data-component-path="src/components/ui/VideoFeatureSection.tsx" data-component-line="161" data-component-end-line="161" data-component-file="VideoFeatureSection.tsx" data-component-name="source" data-component-content="%7B%22elementName%22%3A%22source%22%2C%22src%22%3A%22%2Fvideo%2Fgate-10.mp4%22%2C%22type%22%3A%22video%2Fmp4%22%7D" src="/video/gate-10.mp4" type="video/mp4" />
              </video>

              {/* КНОПКА */}
              <button data-component-id="src/components/ui/VideoFeatureSection.tsx:165:14" data-component-path="src/components/ui/VideoFeatureSection.tsx" data-component-line="165" data-component-end-line="183" data-component-file="VideoFeatureSection.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22type%22%3A%22button%22%7D"
                type="button"
                onClick={toggleVideo}
                aria-label={isPlaying ? 'Pause video' : 'Play video'}
                className={`absolute inset-0 flex items-center justify-center transition-opacity duration-300 ${
                  !isPlaying || showControl ? 'opacity-100' : 'opacity-0'
                }`}
              >
                <div data-component-id="src/components/ui/VideoFeatureSection.tsx:173:16" data-component-path="src/components/ui/VideoFeatureSection.tsx" data-component-line="173" data-component-end-line="182" data-component-file="VideoFeatureSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20h-%5B88px%5D%20w-%5B88px%5D%20items-center%20justify-center%20rounded-full%20border%20border-white%2F60%20bg-black%2F25%20backdrop-blur-md%20transition-transform%20duration-200%20group-hover%3Ascale-105%22%7D" className="flex h-[88px] w-[88px] items-center justify-center rounded-full border border-white/60 bg-black/25 backdrop-blur-md transition-transform duration-200 group-hover:scale-105">
                  {isPlaying ? (
                    <div data-component-id="src/components/ui/VideoFeatureSection.tsx:175:20" data-component-path="src/components/ui/VideoFeatureSection.tsx" data-component-line="175" data-component-end-line="178" data-component-file="VideoFeatureSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20gap-%5B6px%5D%22%7D" className="flex gap-[6px]">
                      <span data-component-id="src/components/ui/VideoFeatureSection.tsx:176:22" data-component-path="src/components/ui/VideoFeatureSection.tsx" data-component-line="176" data-component-end-line="176" data-component-file="VideoFeatureSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22block%20h-%5B22px%5D%20w-%5B6px%5D%20rounded-sm%20bg-white%22%7D" className="block h-[22px] w-[6px] rounded-sm bg-white" />
                      <span data-component-id="src/components/ui/VideoFeatureSection.tsx:177:22" data-component-path="src/components/ui/VideoFeatureSection.tsx" data-component-line="177" data-component-end-line="177" data-component-file="VideoFeatureSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22block%20h-%5B22px%5D%20w-%5B6px%5D%20rounded-sm%20bg-white%22%7D" className="block h-[22px] w-[6px] rounded-sm bg-white" />
                    </div>
                  ) : (
                    <div data-component-id="src/components/ui/VideoFeatureSection.tsx:180:20" data-component-path="src/components/ui/VideoFeatureSection.tsx" data-component-line="180" data-component-end-line="180" data-component-file="VideoFeatureSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22ml-1%20h-0%20w-0%20border-y-%5B12px%5D%20border-y-transparent%20border-l-%5B20px%5D%20border-l-white%22%7D" className="ml-1 h-0 w-0 border-y-[12px] border-y-transparent border-l-[20px] border-l-white" />
                  )}
                </div>
              </button>
            </div>
          </div>

          {/* TEXT */}
          <div data-component-id="src/components/ui/VideoFeatureSection.tsx:188:10" data-component-path="src/components/ui/VideoFeatureSection.tsx" data-component-line="188" data-component-end-line="200" data-component-file="VideoFeatureSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20text-%5B%23b3b3b3%5D%22%7D" className="relative text-[#b3b3b3]">
            <div data-component-id="src/components/ui/VideoFeatureSection.tsx:189:12" data-component-path="src/components/ui/VideoFeatureSection.tsx" data-component-line="189" data-component-end-line="189" data-component-file="VideoFeatureSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22pointer-events-none%20absolute%20-right-4%20-top-4%20h-%5B120px%5D%20w-%5B120px%5D%20border-t%20border-r%20border-purple-500%22%7D" className="pointer-events-none absolute -right-4 -top-4 h-[120px] w-[120px] border-t border-r border-purple-500" />
            <div data-component-id="src/components/ui/VideoFeatureSection.tsx:190:12" data-component-path="src/components/ui/VideoFeatureSection.tsx" data-component-line="190" data-component-end-line="190" data-component-file="VideoFeatureSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22pointer-events-none%20absolute%20-bottom-4%20-left-4%20h-%5B120px%5D%20w-%5B120px%5D%20border-b%20border-l%20border-purple-500%22%7D" className="pointer-events-none absolute -bottom-4 -left-4 h-[120px] w-[120px] border-b border-l border-purple-500" />

            <h2 data-component-id="src/components/ui/VideoFeatureSection.tsx:192:12" data-component-path="src/components/ui/VideoFeatureSection.tsx" data-component-line="192" data-component-end-line="194" data-component-file="VideoFeatureSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22mt-4%20text-%5B32px%5D%20font-bold%20leading-%5B1.1%5D%20text-%5B%23b4b4b4%5D%20sm%3Atext-%5B40px%5D%20lg%3Atext-%5B50px%5D%22%2C%22textContent%22%3A%22The%20world%E2%80%99s%20first-of-Its-kind%20speed%20gate%22%7D" className="mt-4 text-[32px] font-bold leading-[1.1] text-[#b4b4b4] sm:text-[40px] lg:text-[50px]">
              The world’s first-of-Its-kind speed gate
            </h2>

            <p data-component-id="src/components/ui/VideoFeatureSection.tsx:196:12" data-component-path="src/components/ui/VideoFeatureSection.tsx" data-component-line="196" data-component-end-line="199" data-component-file="VideoFeatureSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22mt-6%20max-w-%5B420px%5D%20text-%5B14px%5D%20leading-%5B1.6%5D%20text-white%20sm%3Atext-%5B16px%5D%20lg%3Atext-%5B18px%5D%22%2C%22textContent%22%3A%22We%20presented%20Sweeper-M%20to%20the%20world%20at%20exhibition%20this%20year%20%E2%80%94%20and%20it%20left%20everyone%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20impressed%20and%20in%20love%20with%20its%20design%20and%20innovation.%22%7D" className="mt-6 max-w-[420px] text-[14px] leading-[1.6] text-white sm:text-[16px] lg:text-[18px]">
              We presented Sweeper-M to the world at exhibition this year — and it left everyone
              impressed and in love with its design and innovation.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
